// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2q8bH","options":"AnswerScale_options__1icxd","selected":"AnswerScale_selected__1lq-z"};